import React from 'react';

import {Props as FilterGroupContentProps} from '../FilterGroupContent/FilterGroupContent';
import PriceFilterByPriceType from '../PriceFilterByPriceType/PriceFilterByPriceType';
import PriceInputsWrapper from '../PriceInputsWrapper/PriceInputsWrapper';

type Props = Pick<
    FilterGroupContentProps,
    | 'currency'
    | 'customFiltersParams'
    | 'onCustomFilterUpdate'
    | 'priceFilterOptions'
    | 'priceInputValuesAreValid'
    | 'updatePriceInputValuesValidity'
>;

export type BoundsType = Array<number | null>;

export default function PriceFilterV2(props: Props) {
    const {
        customFiltersParams,
        onCustomFilterUpdate,
        priceFilterOptions = {},
    } = props;
    const {
        appliedMinTotalPrice,
        appliedMaxTotalPrice,
        selectedMinTotalPrice,
        selectedMaxTotalPrice,
        appliedMinNightlyPrice,
        appliedMaxNightlyPrice,
        selectedMinNightlyPrice,
        selectedMaxNightlyPrice,
        selectedFilterByTotalPrice,
    } = customFiltersParams;

    const handleFilterByPriceTypeChange = (filterByTotalPrice) => {
        onCustomFilterUpdate({filterByTotalPrice});
    };

    const handleTotalPriceChange = (newPriceValues) => {
        const {minPrice, maxPrice} = newPriceValues;
        onCustomFilterUpdate({
            minTotalPrice: minPrice,
            maxTotalPrice: maxPrice,
        });
    };

    const handleNightlyPriceChange = (newPriceValues) => {
        const {minPrice, maxPrice} = newPriceValues;
        // support both minPrice and minNightlyPrice for now;
        // remove minPrice support once we no longer longer support filter bar V1
        onCustomFilterUpdate({
            minNightlyPrice: minPrice,
            maxNightlyPrice: maxPrice,
        });
    };

    return (
        <div
            role="menuitem"
            aria-labelledby={`filter-group-label-PriceFilterV2`}
            className={'PriceFilterV2'}
        >
            {!!priceFilterOptions.showFilterByPriceType && (
                <PriceFilterByPriceType
                    isFilterByTotalPriceSelected={selectedFilterByTotalPrice}
                    isFilterByTotalPriceEnabled={
                        !!priceFilterOptions.isFilterByTotalPriceEnabled
                    }
                    onChange={handleFilterByPriceTypeChange}
                />
            )}

            {selectedFilterByTotalPrice && (
                <PriceInputsWrapper
                    {...props}
                    appliedMinPrice={appliedMinTotalPrice}
                    appliedMaxPrice={appliedMaxTotalPrice}
                    selectedMinPrice={selectedMinTotalPrice}
                    selectedMaxPrice={selectedMaxTotalPrice}
                    filterByTotalPrice={selectedFilterByTotalPrice}
                    onInputsWrapperPriceChange={handleTotalPriceChange}
                />
            )}

            {!selectedFilterByTotalPrice && (
                <PriceInputsWrapper
                    {...props}
                    appliedMinPrice={appliedMinNightlyPrice}
                    appliedMaxPrice={appliedMaxNightlyPrice}
                    selectedMinPrice={selectedMinNightlyPrice}
                    selectedMaxPrice={selectedMaxNightlyPrice}
                    filterByTotalPrice={selectedFilterByTotalPrice}
                    onInputsWrapperPriceChange={handleNightlyPriceChange}
                />
            )}
        </div>
    );
}
